"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when try to update/delete a tag which does not exist
 */
class NotFoundError extends client_library_1.ExtendableError {
    constructor(id) {
        super(`Tag with id: ${id} not found`);
    }
}
exports.NotFoundError = NotFoundError;
//# sourceMappingURL=NotFoundError.js.map